import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, useHistory } from "react-router-dom";
import { Alert, Button, Form, FormFeedback, FormGroup, Input, Label } from "reactstrap";
import { updatePassword } from "../actions/admin";

const PASSWORD_REGEX = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/;

const ChangePassword = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector((state) => state.auth.user);
  const [password, setPassword] = useState("");
  const [repassword, setRepassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (!user) {
    return <Redirect to="/login" />;
  }

  const passwordValid = PASSWORD_REGEX.test(password);
  const passwordsMatch = password.length > 0 && password === repassword;

  const handleSubmit = (event) => {
    event.preventDefault();
    setError("");

    if (!passwordValid) {
      setError("La password deve contenere da 8 a 15 caratteri, almeno una maiuscola, una minuscola, un numero e un carattere speciale, senza spazi.");
      return;
    }

    if (!passwordsMatch) {
      setError("Le password non coincidono.");
      return;
    }

    setLoading(true);
    dispatch(updatePassword({ id: user.id, password }))
      .then((response) => {
        const updatedUser = {
          ...JSON.parse(localStorage.getItem("user")),
          passwordChangeRequired: false,
        };
        localStorage.setItem("user", JSON.stringify(updatedUser));
        setLoading(false);
        alert(response.message || "Password modificata!");
        history.push("/home");
        window.location.reload();
      })
      .catch((err) => {
        setLoading(false);
        const message = err?.response?.data?.message || "Impossibile modificare la password.";
        setError(message);
      });
  };

  return (
    <div className="col-md-12">
      <div className="card card-container">
        <h3 className="text-center mb-4">Cambio password obbligatorio</h3>
        <p>
          La password è scaduta. Per continuare a utilizzare l'applicazione devi impostare una nuova password.
        </p>
        <p className="text-muted">
          La nuova password non può essere uguale a quella appena scaduta o a quella precedente.
        </p>

        {error && <Alert color="danger">{error}</Alert>}

        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label for="password">Nuova password</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              invalid={password.length > 0 && !passwordValid}
              disabled={loading}
              autoComplete="new-password"
              required
            />
            <FormFeedback>
              8-15 caratteri, maiuscola, minuscola, numero e carattere speciale.
            </FormFeedback>
          </FormGroup>

          <FormGroup>
            <Label for="repassword">Conferma nuova password</Label>
            <Input
              id="repassword"
              type="password"
              value={repassword}
              onChange={(e) => setRepassword(e.target.value)}
              invalid={repassword.length > 0 && !passwordsMatch}
              valid={passwordsMatch}
              disabled={loading}
              autoComplete="new-password"
              required
            />
            <FormFeedback>Le password non coincidono.</FormFeedback>
            <FormFeedback valid>Le password coincidono.</FormFeedback>
          </FormGroup>

          <Button color="primary" block disabled={loading || !passwordValid || !passwordsMatch}>
            {loading ? "Salvataggio..." : "Cambia password"}
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default ChangePassword;
